import { IPageResponse } from '../common/interfaces/IPageResponse';
import { ISortedPageRequest } from '../common/interfaces/IPageRequest';

export interface ICustomerCardsState {
  customerId: number | null;
  currentTableView: ICustomerCardType;
  discountCards: IPageResponse<ICustomerCard> | null;
  paymentCards: IPageResponse<ICustomerCard> | null;
  nonActivatedCards: IPageResponse<ICustomerCard> | null;
  cardCounts: ICardsCount;
  showBlockedCards: boolean;
  pageRequest: ICustomerCardRequest;
  nonActivatedPageRequest: ICustomerCardRequest;
  isNewCardModalVisible: boolean;
  isIdCreditCardModalVisible: boolean;
  newCardType?: ICustomerCardType;
  isChangeCustomerCardModalVisible: boolean;
  isViewPinModalVisible: boolean;
  selectedCustomerCard: ICustomerCard | null;
  isRequesting: boolean;
  isRequestingNonActivated: boolean;
  isCreditApplicationModalVisible: boolean;
  selectedCardNumbers: string[];
  isActivateModalVisible: boolean;
}
export interface ICustomerCardsSearchBarState {
  searchQuery: string | null;
  selectedCardType: ICustomerCardType;
  showBlockedCards: boolean;
}

interface ICardsCount {
  paymentCards: {
    active: number | null;
    disabled: number | null;
  } | null;
  discountCards: {
    active: number | null;
    disabled: number | null;
  } | null;
}

export interface ICustomerCard {
  id: number;
  remoteCardId: string;
  cardType: ICustomerCardType;
  name: string;
  isBlocked: boolean;
  isActivated: boolean;
  isEidCard: boolean;
  monthlyLimit: number | null;
  customerBalanceLimit: number | null;
  creditRemaining: number;
  creditUsed: number | null;
  dateCreated: string;
  dateExpiry?: string;
  isExpired: boolean;
  customerDiscountGroup?: string;
  customerLocationId?: number;
}

export interface ICustomerCardRequest
  extends ISortedPageRequest<ICustomerCardsSortFields> {
  cardType?: ICustomerCardType;
  searchQuery?: string;
  isBlockedCard?: boolean;
  isActivated?: boolean;
}

export enum ICustomerCardsSortFields {
  REMOTE_CARD_ID = 'REMOTE_CARD_ID',
  CARD_TYPE = 'CARD_TYPE',
  NAME = 'NAME',
  IS_BLOCKED_CARD = 'IS_BLOCKED_CARD',
  MONTHLY_LIMIT = 'MONTHLY_LIMIT',
  CREDIT_REMAINING = 'CREDIT_REMAINING',
  DATE_CREATED = 'DATE_CREATED',
}

export enum ICustomerCardType {
  PAYMENT_CARD = 'PAYMENT_CARD',
  DISCOUNT_CARD = 'DISCOUNT_CARD'
}

export interface CustomerCardActivateResult {
  succeeded: string[];
  failed: string[];
}